// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pagination-box[data-v-87441066]{margin-top:16px}.radioClass[data-v-87441066]{width:100%;padding:0 10px;box-sizing:border-box;border:1px solid #dcdfe6;border-radius:3px;display:flex;flex-wrap:wrap}.letClass[data-v-87441066]{display:flex;align-items:center;margin-top:10px}", ""]);
// Exports
module.exports = exports;
